import React from 'react';
import { connect } from 'react-redux';
import './PublicKey.css';
import * as actions from '../actions.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
    InputGroup,
    FormControl,
    Button,
} from 'react-bootstrap';



function Slot({title, children}) {
    return <div title={title} className="slot">
        {
            typeof children === 'string'
            ? <div className="slotcontent">{ children }</div>
            : children
        }
        <div className="slottitle">{ title }</div>
    </div>;
}

function PublicKeyDemo({
    seed,
    privateKey,
    wif,
    publicKey,
    publicAddress,
    changeSeed,
    generateSeed,
    generatePrivateKey,
    toggleWif,
    generatePublicKey,
    generatePublicAddress,
    reset,
}) {
    return (
        <Grid>
            <PageHeader>
                Public Key Encryption Demonstration
            </PageHeader>
            <Row>
                <Col sm={12}>
                    <Slot title="Seed">
                        <InputGroup>
                            <InputGroup.Button>
                                <Button bsStyle="catallaxy" disabled={!!privateKey} onClick={generateSeed}>Random</Button>
                            </InputGroup.Button>
                            <FormControl
                                type="text"
                                className="seedinput"
                                value={seed}
                                placeholder='Enter text or click "Random"'
                                onChange={ev => changeSeed(ev.target.value)}
                                disabled={privateKey}
                            />
                            <InputGroup.Button>
                                <Button bsStyle="catallaxy" onClick={reset}>Reset</Button>
                            </InputGroup.Button>
                        </InputGroup>
                    </Slot>
                </Col>
            </Row>

            <Row className={'slotarrow ' + (privateKey ? "slotvisible" : "slotnotvisible")}> 🡻 </Row>
            <div className={privateKey ? 'slotbuttonnotvisible' : 'slotbuttonvisible'}>
                <Button bsStyle="catallaxy" onClick={generatePrivateKey}>Generate Private Key</Button>
            </div>

            <Row className={privateKey ? "slotvisible" : "slotnotvisible"}>
                <Col sm={12}>
                    <Slot title="Private Key">
                        <Col sm={11} className="privatekeycol">
                            <div className="slotcontent">{ wif || privateKey }</div>
                        </Col>
                        <Col sm={1}>
                            <Button bsStyle="catallaxy" onClick={toggleWif}>{wif ? 'key' : 'WIF'}</Button>
                        </Col>
                    </Slot>
                </Col>
            </Row>

            <Row className={'slotarrow ' + (publicKey ? "slotvisible" : "slotnotvisible")}> 🡻 </Row>
            <div className={(privateKey && !publicKey) ? "slotbuttonvisible" : "slotbuttonnotvisible" }>
                <Button bsStyle="catallaxy" onClick={generatePublicKey}>Derive Public Key</Button>
            </div>

            <Row className={publicKey ? "slotvisible" : "slotnotvisible"}>
                <Col sm={12}>
                    <Slot title="Public Key">{ publicKey }</Slot>
                </Col>
            </Row>

            <Row className={'slotarrow ' + (publicAddress ? "slotvisible" : "slotnotvisible")}> 🡻 </Row>
            <div className={(publicKey && !publicAddress) ? "slotbuttonvisible" : "slotbuttonnotvisible" }>
                <Button bsStyle="catallaxy" onClick={generatePublicAddress}>Generate Public Address</Button>
            </div>

            <Row className={publicAddress ? "slotvisible" : "slotnotvisible"}>
                <Col sm={12}>
                    <Slot title="Public Address">{ publicAddress }</Slot>
                </Col>
            </Row>
        </Grid>
    );
}

function stateToProps({ publicKey }) {
    return publicKey;
}
function dispatchToProps(dispatch) {
    return {
        changeSeed(val) {
            dispatch(actions.pubKeyEditSeed(val));
        },
        generateSeed() {
            dispatch(actions.pubKeyGenerateSeed());
        },
        generatePrivateKey() {
            dispatch(actions.pubKeyGeneratePrivateKey());
        },
        toggleWif() {
            dispatch(actions.pubKeyToggleWif());
        },
        generatePublicKey() {
            dispatch(actions.pubKeyGeneratePublicKey());
        },
        generatePublicAddress() {
            dispatch(actions.pubKeyGeneratePublicAddress());
        },
        reset() {
            dispatch(actions.pubKeyReset());
        },
    };
}

export default connect(stateToProps, dispatchToProps)(PublicKeyDemo);






// WEBPACK FOOTER //
// ./src/components/PublicKey.js